var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.reloadRow}},[_vm._v("Reload row")])])
}
var staticRenderFns = []

export { render, staticRenderFns }